module.exports = __webpack_public_path__ + "img/CarOnline-Training.38a5d687.png";